import { render, staticRenderFns } from "./Emulation.vue?vue&type=template&id=b989c2a4&"
import script from "./Emulation.vue?vue&type=script&lang=js&"
export * from "./Emulation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports